:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._shrink-1{flex-shrink:1;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._grow-0{flex-grow:0;}
:root ._fd-row{flex-direction:row;}
:root ._items-center{align-items:center;}
:root ._ml-t-space-med104641{margin-left:var(--t-space-medium);}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}